import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Table, Paragraph } from "@zillow/constellation-10";
import "react";
import MortgageRatesTableModal from "./MortgageRatesTableModal.esm.js";
const MortgageRatesTableContainer = ({
  children,
  ...props
}) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(Table.Responsive, { children: /* @__PURE__ */ jsx(Table.Root, { appearance: "horizontal", "aria-label": "Mortgage rates by program", size: "md", children }) }),
  /* @__PURE__ */ jsxs(Paragraph, { textStyle: "fineprint-sm", css: {
    padding: "default"
  }, children: [
    "Last updated ",
    props == null ? void 0 : props.updatedAt,
    ".",
    " ",
    /* @__PURE__ */ jsx(MortgageRatesTableModal, { ...props })
  ] })
] });
export {
  MortgageRatesTableContainer as default
};
